import { getAppDisplayName } from '@/utils/apps';

export const inviteConfirmationErrors = Object.freeze({
    INVALID: 'invalid invitation data',
    EXPIRED: 'invitation expired',
    KEY_ISSUE: 'invalid invitation key',
});

export function transformInitResponse (data) {
    const isAEUSubscription = data?.activeSubscription?.productLines?.find((pl) => pl.type === 'adoptEndUser' && pl.purchased);
    if (!isAEUSubscription) {
        return data;
    }

    try {
        return initAEUSubscription({ data });
    } catch {
        return data;
    }
}

export function initAEUSubscription (res) {
    return {
        ...res.data,
        activeSubscription: {
            ...res.data.activeSubscription,
            applications: res.data.activeSubscription.applications.map((app) => {
                return {
                    ...app,
                    displayName: getAppDisplayName(app),
                };
            }),
        },
        subscriptions: res.data.subscriptions.map((sub) => {
            return {
                ...sub,
                applications: sub.applications ? sub.applications.map((app) => {
                    return {
                        ...app,
                        displayName: getAppDisplayName(app),
                    };
                }) : undefined,
            };
        }),
    };
}
